/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const CElementGraphique = require('./CElementGraphique')
module.exports = CSurfaceAncetre

/**
 * Classe ancêtre de toutes les surfaces.
 * @constructor
 * @extends CElementGraphique
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Color} couleur : La couleur.
 * @param {Boolean} masque : true si l'objet est masqué.
 * @param {mtg32.StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
 */
function CSurfaceAncetre (listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage) {
  if (arguments.length === 0) return; // Ajout version 4.9.9.4
  if (arguments.length === 1) CElementGraphique.call(this, listeProprietaire);
  else {
    CElementGraphique.call(this, listeProprietaire, impProto, estElementFinal, couleur, true, 0, 0, masque, "", 16);
    this.styleRemplissage = styleRemplissage;
  }
}
CSurfaceAncetre.prototype = new CElementGraphique();
CSurfaceAncetre.prototype.constructor = CSurfaceAncetre;
CSurfaceAncetre.prototype.superClass = "CElementGraphique";
CSurfaceAncetre.prototype.className = "CSurfaceAncetre";

CSurfaceAncetre.prototype.getNature = function() {
  return NatObj.NSurface;
};
CSurfaceAncetre.prototype.confonduAvec = function(p) {
  if (p.className === this.className) {
    return (this.styleRemplissage === p.styleRemplissage);
  }
  else return false;
};
CSurfaceAncetre.prototype.chaineDesignation= function() {
  return "desSurface";
};
CSurfaceAncetre.prototype.peutGenererLieuObjet = function() {
  return false;
}
CSurfaceAncetre.prototype.read = function(inps, list){
  CElementGraphique.prototype.read.call(this, inps, list);
  this.styleRemplissage = inps.readInt();
};
CSurfaceAncetre.prototype.write = function(oups, list){
  CElementGraphique.prototype.write.call(this, oups, list);
  oups.writeInt(this.styleRemplissage);
} ;



// WEBPACK FOOTER //
// ./src/objets/CSurfaceAncetre.js